import { render, staticRenderFns } from "./BDXManagementTableFilters.vue?vue&type=template&id=10ae6bcd&scoped=true"
import script from "./BDXManagementTableFilters.vue?vue&type=script&lang=js"
export * from "./BDXManagementTableFilters.vue?vue&type=script&lang=js"
import style0 from "./BDXManagementTableFilters.vue?vue&type=style&index=0&id=10ae6bcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae6bcd",
  null
  
)

export default component.exports